import React, { Component } from "react";
import { Navigate } from "react-router-dom";
import { Modal, Button }  from 'react-bootstrap';

import { FaFlag } from 'react-icons/fa6';

import { getDemoHomePath } from "../utils/demoUtils";

class ErrorModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            redirect: null,
            show: false,
            title: this.props.title,
            text: this.props.text
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot){
        if (this.props.show !== prevState.show) {
            this.setState({
                show: this.props.show,
                title: this.props.title,
                text: this.props.text,
                // WEB-413 -- a path to /go/<slug> when this is an expired
                // visit rather than a fault. Null for every other error, and
                // then the footer looks exactly as it always has.
                restart: this.props.restart || null
            }, () => {
                this.addjustLinebreak();
            })
        }
    }

    addjustLinebreak(){
        let class_name = ".error-modal .text";
        let dom = document.querySelector(class_name)
        if(dom){
            dom.innerHTML = "";
            let new_text = this.state.text
            new_text = new_text.split(/(?:\r\n|\r|\n)/g);
            for(var i=0; i<new_text.length; i++){
                if(new_text[i]) {
                    let p = document.createElement("li");
                    p.textContent = new_text[i];
                    dom.appendChild(p);
                }
            }
        }
    }

    hideModal(){
        this.setState({
            show: false
        })
    }

    goHome(){
        this.setState({ redirect: { path: getDemoHomePath(), state: null } });
    }

    render() {
        if (this.state.redirect) {
            return <Navigate to={this.state.redirect.path} state={this.state.redirec} />
        }
        return (
            <Modal className="error-modal" show={this.state.show} animation={true} centered>
                <Modal.Header>
                    <Modal.Title className="w-100 text-center">
                        <div><FaFlag style={{ color: "#dc3545" }} /> {this.state.title}</div>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="pb-0">
                    <div className="container">
                        <div className="row">
                            <div className="col text-center">
                                <img src="/assets/images/ref-football-flag-out.png" width={"200px"}/>
                            </div>
                            <div className="col text-start d-flex align-items-center">
                                <ul className="text"></ul>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className="container m-0 p-0">
                        <div className="row">
                            {/* WEB-413 -- when the visit has merely expired,
                                Restart is the only thing the player wants and
                                the only thing that works. It leads, and the
                                lobby link steps back to secondary. A full page
                                load, not a route change: /go/ is served by the
                                server, not by this app. */}
                            {this.state.restart ? (
                                <div className="col d-grid">
                                    <Button variant="primary"
                                            onClick={e => window.location.assign(this.state.restart)}>
                                        Restart
                                    </Button>
                                </div>
                            ) : (
                                <div className="col d-grid"><Button variant="primary" onClick={e => this.goHome()}>Return to Lobby</Button></div>
                            )}
                        </div>
                    </div>
                </Modal.Footer>
            </Modal>
        )
    }
}
export default ErrorModal;